import Etage from 'interfaces/Etage'

interface ParamsProps {
  surfaceInput: number
  calculViaConfigurateurAvance: boolean
  garagePosition: number | null
  tailleGarage: number | null
  etages: Etage[]
}

interface ReturnProps {
  surfaceHabitableMin: number
  surfaceHabitableMax: number
  surfaceAuSolMin: number
  surfaceAuSolMax: number
}

const HABITABLE_INPUT_TO_MIN_MAX_RATIO = 0.1
const AUTRES_SURFACES_NON_HABITABLES_RATIO = 0.2
const MURS_RATIO = 0.1

const getSurfaceGarage = (
  calculViaConfigurateurAvance: boolean,
  garagePosition: number | null,
  tailleGarage: number | null
): number => {
  let surfaceGarage = 0
  if (
    calculViaConfigurateurAvance &&
    garagePosition === 2 &&
    tailleGarage !== null
  ) {
    surfaceGarage = tailleGarage
  }
  return surfaceGarage
}

const calculSurfacesAuSol = (
  surfaceInput: number,
  etages: Etage[],
  calculViaConfigurateurAvance: boolean,
  garagePosition: number | null,
  tailleGarage: number | null
): { surfaceAuSolMin: number; surfaceAuSolMax: number } => {
  const coefficientEtages =
    1 + etages.reduce((total, obj) => total + obj.width, 0) / 100

  const surfaceGarage = getSurfaceGarage(
    calculViaConfigurateurAvance,
    garagePosition,
    tailleGarage
  )

  const autresSurfaceNonHabitable =
    surfaceInput * AUTRES_SURFACES_NON_HABITABLES_RATIO

  const surfaceAuSolMin = Math.floor(
    (surfaceInput + surfaceGarage) / coefficientEtages
  )
  const surfaceAuSolMax = Math.ceil(
    ((surfaceInput + surfaceGarage + autresSurfaceNonHabitable) /
      coefficientEtages) *
      (1 + MURS_RATIO)
  )

  return { surfaceAuSolMin, surfaceAuSolMax }
}

export const calculAllSurfaces = ({
  surfaceInput,
  calculViaConfigurateurAvance,
  garagePosition,
  tailleGarage,
  etages,
}: ParamsProps): ReturnProps => {
  const surfaceHabitableMin = Math.floor(
    surfaceInput * (1 - HABITABLE_INPUT_TO_MIN_MAX_RATIO)
  )
  const surfaceHabitableMax = Math.ceil(
    surfaceInput * (1 + HABITABLE_INPUT_TO_MIN_MAX_RATIO)
  )

  const { surfaceAuSolMin, surfaceAuSolMax } = calculSurfacesAuSol(
    surfaceInput,
    etages,
    calculViaConfigurateurAvance,
    garagePosition,
    tailleGarage
  )

  return {
    surfaceHabitableMin,
    surfaceHabitableMax,
    surfaceAuSolMin,
    surfaceAuSolMax,
  }
}

export default calculAllSurfaces
